export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-grid-select/index.js